module.exports = __webpack_public_path__ + "static/media/hackingflix_logo.7204b4c2.png";